<template>
  <div
    id="inspire"
    class="bg-dark"
    :style="{
      backgroundImage: `linear-gradient(rgba(2, 2, 2, 0.75), rgba(0, 0, 0, 0.75)), url('${backgroundUrl}')`,
      backgroundSize: '100%',
      minHeight: '100vh'
    }"
  >
    <div class="container">
      <div id="challange-target">hidden</div>
      <div class="row marginTop">
        <div class="col-md-12">
          <v-app style="margin: 0; background-color: transparent;">
            <div class="row" v-for="list in listing" :key="list.id">
              <div class="col-md-6">
                <v-carousel>
                  <v-carousel-item
                    @click="eventImages(list.images)"
                    v-for="image in list.images"
                    :key="image.id"
                    :src="image.image_path"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                  ></v-carousel-item>
                </v-carousel>
              </div>

              <!-- Modal -->
              <div
                class="modal fade bd-example-modal-lg"
                id="imageUp"
                tabindex="-1"
                role="dialog"
                aria-labelledby="addNewLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                    <v-carousel height="100%">
                      <v-carousel-item
                        v-for="img in imageArray"
                        :key="img.id"
                        :src="img.image_path"
                        reverse-transition="fade-transition"
                        transition="fade-transition"
                      ></v-carousel-item>
                    </v-carousel>
                  </div>
                </div>
              </div>
              <!-- close modal  -->

              <div class="col-md-6">
                <v-alert
                  v-if="list.status == true"
                  border="bottom"
                  class="m-0"
                  style="background: linear-gradient(90deg, rgba(50,145,12,0.4234068627450981) 0%, rgba(11,52,7,0.6166841736694677) 35%, rgba(35,152,17,0.33657212885154064) 100%);"
                  dark
                >
                  <p class="m-0 text-center bold text-white">
                    <b>PENDING</b>
                  </p>
                </v-alert>

                <v-btn block color="#00BCD4" id="p-remove" dark
                  ><h2>${{ list.price }}</h2>
                  USD</v-btn
                >

                <div class="alert alert-dark" role="alert">
                  <h3 clasS="text-center">{{ list.address }}</h3>
                  <div
                    class="row mb-1"
                    style="border-radius: 5px; background-color: #81D4FA;"
                  >
                    <div
                      class="col-md-6"
                      style="border-right: 2px solid #37474F;"
                    >
                      <strong>Bedroom: </strong>{{ list.bedroom }}<br />
                      <strong>Bathroom: </strong>{{ list.bathroom }}<br />
                    </div>

                    <div class="col-md-6">
                      <strong>Year Built: </strong>{{ list.year_built }}<br />
                      <strong>Sq. Footage: </strong>{{ list.square_footage
                      }}<br />
                      <strong>Acreage: </strong>{{ list.acreage }}
                    </div>
                  </div>

                  <div
                    class="row mb-1 p-2"
                    style="border-radius: 5px; background-color: #FFCDD2;"
                  >
                    <strong>Features: </strong> {{ list.features }}<br />
                  </div>

                  <v-card class="mb-4">
                    <v-card-text class="text--primary">
                      <div>
                        <strong>Description: </strong><br />
                        {{ list.description }}
                      </div>
                      <div class="mt-2">
                        <strong>Included Items: </strong><br />
                        {{ list.included_items }}
                      </div>
                    </v-card-text>
                  </v-card>
                </div>

                <a
                  @click="contactPage(list)"
                  target="_blank"
                  class="btn btn-info btn-block text-white p-2"
                  ><h3>Contact Now!</h3></a
                >
              </div>
            </div>
          </v-app>
        </div>
      </div>
    </div>
  </div>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
export default {
  data() {
    return {
      listing: [],
      backgroundUrl: "",
      imageArray: []
    };
  },
  created() {
    this.getRental();
  },

  methods: {
    contactPage(list) {
      this.$router.push({ name: "contactListing", params: { id: list } });
    },

    eventImages(value) {
      this.imageArray = value;
      $("#imageUp").modal("show");
    },

    getRental() {
      window.axios.get("/api/inventory/" + this.$route.params.id).then(res => {
        this.listing = res.data;
        this.backgroundUrl = res.data[0].images[0].image_path;
      });
    }
  }
};
</script>
<style scoped>
#p-remove {
  height: 4em;
}

@media (max-width: 1026px) {
  #p-remove {
    height: 6em;
  }
}

.modal .modal-dialog {
  width: 100%;
  height: 100%;
  max-width: 95%;
  min-height: 100vh;
}
</style>
